import React from 'react';
import ClayTabs from '@clayui/tabs';
import "./TabNavigation.css"
interface TabItem {
    title: string;
    statusKey: string;
    tooltip?: string;
}

interface TabComponentProps {
    active: number;
    setActive: (active: number) => void;
    visibleTabs: TabItem[];
}

const TabComponent: React.FC<TabComponentProps> = ({
    active,
    setActive,
    visibleTabs
}) => {
    return (
        <ClayTabs
            active={active}
            onActiveChange={setActive}
            className="table-tabs"
        >
            {visibleTabs?.map((item) => (
                <ClayTabs.Item key={item.title} className="table-tab" title={item.tooltip}>
                    {item.title}
                </ClayTabs.Item>
            ))}
        </ClayTabs>
    );
};

export default TabComponent;
